import { getLocalStorage } from "@/utils/localstorage";

export function mapLocalStorageUserMetaToPayload(): Record<string, unknown> {
    if (!window) {
        return {};
    }
    try {
        const atl_first_visit = getLocalStorage("atl_first_visit", true);
        const userMeta = atl_first_visit
            ? {
                  userMeta: JSON.stringify({
                      firstVisitActivationContext: JSON.parse(atl_first_visit)
                  })
              }
            : {};

        return userMeta;
    } catch (error) {
        console.error(
            "Error mapping local storage user meta to payload",
            error
        );
        return {};
    }
}
